import { createFileRoute } from '@tanstack/react-router'

import { PlatformActivitiesPage } from '../../../components/pages/backoffice/platform/platform-activities-page/platform-activities-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/activities')({
  component: () => (
    <PermissionChecker requiredPermissions={['activity.read']}>
      <PlatformActivitiesPage />
    </PermissionChecker>
  ),
})
